export default __webpack_public_path__ + "static/media/blue-left-thin.06ffd619.svg";